// @ts-nocheck
import React from 'react'

const SensitivityModelStyleUpdate = ({dataSourceRecord, onChange}) => {
    const [id] = Object.keys(dataSourceRecord)
    const record = dataSourceRecord[id]
    const {resource, renderProps} = record
    
    if (!renderProps || !renderProps.variations) {
        return (
            <div className="text-gray-500 text-center py-4">
                No parameters available for this model
            </div>
        );
    }
    
    const { currentVariation, selectedChannel, variations } = renderProps

    // Format key for display (Example: "wind_speed" => "Wind Speed")
    const formatName = (key) => {
        return key.split('_')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(' ');
    }

    // Handle selection of a variation
    const handleVariationSelect = (variationKey) => {
        const updatedRenderProps = structuredClone(renderProps)
        updatedRenderProps.currentVariation = variationKey
        
        onChange({
            [id]: {
                ...record,
                renderProps: updatedRenderProps
            }
        })
    }

    // Handle selection of a channel
    const handleChannelSelect = (channelKey) => {
        const updatedRenderProps = structuredClone(renderProps)
        updatedRenderProps.selectedChannel = channelKey
        
        onChange({
            [id]: {
                ...record,
                renderProps: updatedRenderProps
            }
        })
    }

    return (
        <div>
            {/* Variation selection section */}
            <div className="mb-4">
                <div className="text-gray-700 font-medium text-xs mb-2">
                    Select Parameter:
                </div>
                <div className="grid grid-cols-3 gap-1">
                    {Object.keys(variations).map((variation) => (
                        <button
                            key={`variation-${variation}`}
                            onClick={() => handleVariationSelect(variation)}
                            className={`px-2 py-1 border text-xs text-left rounded-md transition-colors ${
                                currentVariation === variation
                                    ? 'bg-blue-50 border-blue-500 font-medium text-blue-700'
                                    : 'bg-gray-50 border-gray-300 text-gray-500 hover:bg-gray-100'
                            }`}
                        >
                            {formatName(variation)}
                        </button>
                    ))}
                </div>
            </div>
            
            {/* Channel selection section */}
            <div>
                <div className="text-gray-700 font-medium text-xs mb-2 flex justify-between items-center">
                    <span>Select Adjustment:</span>
                    {currentVariation && (
                        <div className="text-xs text-gray-500">
                            Parameter: {formatName(currentVariation)}
                        </div>
                    )}
                </div>
                <div className="grid grid-cols-3 gap-1">
                    {/* Show baseline option first */}
                    <button
                        key="baseline-option"
                        onClick={() => handleChannelSelect('baseline')}
                        className={`px-2 py-1 border text-xs text-left rounded-md transition-colors ${
                            selectedChannel === 'baseline'
                                ? 'bg-blue-50 border-blue-500 font-medium text-blue-700'
                                : 'bg-gray-50 border-gray-300 text-gray-500 hover:bg-gray-100'
                        }`}
                    >
                        Baseline
                    </button>
                    
                    {/* Show all other channels */}
                    {currentVariation && variations[currentVariation] && 
                        Object.keys(variations[currentVariation]).map((channel) => (
                            <button
                                key={`channel-${channel}`}
                                onClick={() => handleChannelSelect(channel)}
                                className={`px-2 py-1 border text-xs text-left rounded-md transition-colors ${
                                    selectedChannel === channel
                                        ? 'bg-blue-50 border-blue-500 font-medium text-blue-700'
                                        : 'bg-gray-50 border-gray-300 text-gray-500 hover:bg-gray-100'
                                }`}
                            >
                                {channel}
                            </button>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export default SensitivityModelStyleUpdate